import TripItemEuRailRecommendation from './trip-item-eurail-recommendation-component';
import TripItemEuRailRecommendationService from './trip-item-eurail-recommendation-service';
import './trip-item-eurail-recommendation.scss';

const MODULE_NAME = 'app.trip.item-eurail-recommendation';
const module = angular.module(MODULE_NAME, [])
    .directive(TripItemEuRailRecommendation.DIRECTIVE_NAME, TripItemEuRailRecommendation)
    .service('tripItemEuRailRecommendationService', TripItemEuRailRecommendationService);

export {module, MODULE_NAME as default};



// WEBPACK FOOTER //
// ./src/app/modules/trip/trip-item-recommendation/trip-item-eurail-recommendation/trip-item-eurail-recommendation-module.js